import { yupResolver } from '@hookform/resolvers';

import { useUserInfoState } from 'src/front/contexts/SessionContext';
import * as Yup from 'yup';

interface Options {
  todayMaxControl?: boolean;
  todayMinControl?: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useYupResolver = (schema: Yup.ObjectSchema, options?: Options, context?: any): any => {
  const { processDate } = useUserInfoState();

  if (!options) {
    return yupResolver(schema);
  }

  return yupResolver(schema, {
    abortEarly: false,
    context: {
      ...context,
      ...(options.todayMaxControl
        ? { todayMaxControl: new Date(processDate || new Date().setHours(24, 0, 0, 0) - 1) }
        : {}),
      ...(options.todayMinControl
        ? { todayMinControl: new Date(processDate || new Date().setHours(0, 0, 0, 0)) }
        : {}),
    },
  });
};

export default useYupResolver;
